const GraphQLQuery = require('app/graphql/Query');
const ListTable = require('app/ui/list/Table');

class RestaurantsTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'seller': {'id':null,'name':null},
            'tableContainerSelector': '.restaurants-list-container',

            'restaurantShowBaseUrl': window.App.get('restaurantShowBaseUrl'),
            'restaurantAnalyseBaseUrl': window.App.get('restaurantAnalyseBaseUrl'),
            'restaurantUsersBaseUrl': window.App.get('restaurantUsersBaseUrl'),
            'restaurantSupplierBaseUrl': window.App.get('restaurantSupplierBaseUrl'),
            'restaurantBookmarkBaseUrl': window.App.get('restaurantBookmarkBaseUrl'),
            'restaurantCopyBaseUrl': window.App.get('restaurantCopyBaseUrl'),
            'restaurantStatBaseUrl': window.App.get('restaurantStatBaseUrl'),
            'restaurantTrameBaseUrl': window.App.get('restaurantTrameBaseUrl'),
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }
		
		this.$tableContainer = $(this.settings.tableContainerSelector,this.$container);

        this.seller = this.settings.seller;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.buildTab();
    }

    buildTab(){
        this.$container
        .html('')
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-12 p-2 restaurants-list-container white-box')
            )
        );
		this.buildRestaurantsList();
    }

	buildRestaurantsList(){
        var self = this;

        let fields = [
			'restaurants { id name createdAt }'
        ];

        let attributes = {
            'queryType': 'seller',
            'parameters': {
				'id' : this.seller.id,
			},
            'fields': fields,

            'success': function(data){

				this.table = new ListTable({
					'$container': $('.restaurants-list-container'),
					'tableClass': 'table table-striped restaurants-list',
					'id': 'list-restaurants',
					'length': 5000,
					'data' : data.restaurants,
					'columns': [
						{
							'name': 'createdAt',
							'label': window.translate('restaurant.order.createdAt.label'),
							'class': 'restaurant-date',
							'ordered': true,
							'orderType': 'createdAt',
							'orderDir': 'DESC',
							'render': function(item,index){
								return window.formatDate(item.createdAt,window.translate('momentDateFormat.fullDay'));
							},
						},
						{
							'name': 'name',
							'label': 'Nom',
							'class': 'restaurant-name',
							'render': function(item,index){
								return item.name;
							},
						},
						{
							'name': 'actions',
							'label': '',
							'class': 'order-actions',
							'render': function(item,index){
								let $list = $('<ul/>')
								.addClass('list-inline btn-list-inline');
		
								let btns = [];
		
								let urlEdit = self.settings.restaurantShowBaseUrl.replace('__ID__',item.id);
								let $btnEdit = $('<a/>')
								.attr('href',urlEdit)
								.addClass('btn btn-link iframe fancy')
								.attr('data-fancybox','')
								.attr('data-type','iframe')
								.attr('title',window.translate('restaurant.actions.edit.label'))
								.append(
									$('<i/>')
									.addClass('fas fa-edit')
								);
								btns.push($btnEdit);
		
								let urlAnalyse = self.settings.restaurantAnalyseBaseUrl.replace('__ID__',item.id);
								let $btnAnalyse = $('<a/>')
								.attr('href',urlAnalyse)
								.addClass('btn btn-link iframe fancy')
								.attr('data-fancybox','')
								.attr('data-type','iframe')
								.attr('title',window.translate('restaurant.actions.analyse.label'))
								.append(
									$('<i/>')
									.addClass('fas fa-chart-pie')
								);
								btns.push($btnAnalyse);
		
								let urlUser = self.settings.restaurantUsersBaseUrl.replace('__ID__',item.id);
								let $btnUser = $('<a/>')
								.attr('href',urlUser)
								.addClass('btn btn-link iframe fancy')
								.attr('data-fancybox','')
								.attr('data-type','iframe')
								.attr('title',window.translate('restaurant.actions.user.label'))
								.append(
									$('<i/>')
									.addClass('fas fa-users')
								);
								btns.push($btnUser);
		
								let urlSupplier = self.settings.restaurantSupplierBaseUrl.replace('__ID__',item.id);
								let $btnSupplier = $('<a/>')
								.attr('href',urlSupplier)
								.addClass('btn btn-link iframe fancy')
								.attr('data-fancybox','')
								.attr('data-type','iframe')
								.attr('title',window.translate('restaurant.actions.supplier.label'))
								.append(
									$('<i/>')
									.addClass('fas fa-truck')
								);
								btns.push($btnSupplier);
		
								let urlBookmark = self.settings.restaurantBookmarkBaseUrl.replace('__ID__',item.id);
								let $btnBookmark = $('<a/>')
								.attr('href',urlBookmark)
								.addClass('btn btn-link iframe fancy')
								.attr('data-fancybox','')
								.attr('data-type','iframe')
								.attr('title',window.translate('restaurant.actions.bookmark.label'))
								.append(
									$('<i/>')
									.addClass('fas fa-star')
								);
								btns.push($btnBookmark);
		
								let urlCopy = self.settings.restaurantCopyBaseUrl.replace('__ID__',item.id);
								let $btnCopy = $('<a/>')
								.attr('href',urlCopy)
								.addClass('btn btn-link iframe fancy')
								.attr('data-fancybox','')
								.attr('data-type','iframe')
								.attr('title',window.translate('restaurant.actions.copy.label'))
								.append(
									$('<i/>')
									.addClass('fas fa-copy')
								);
								btns.push($btnCopy);
		
								let urlStat = self.settings.restaurantStatBaseUrl.replace('__ID__',item.id);
								let $btnStat = $('<a/>')
								.attr('href',urlStat)
								.addClass('btn btn-link iframe fancy')
								.attr('data-fancybox','')
								.attr('data-type','iframe')
								.attr('title',window.translate('restaurant.actions.stat.label'))
								.append(
									$('<i/>')
									.addClass('fas fa-chart-line')
								);
								btns.push($btnStat);
		
								let urlTrame = self.settings.restaurantTrameBaseUrl.replace('__ID__',item.id);
								let $btnTrame = $('<a/>')
								.attr('href',urlTrame)
								.addClass('btn btn-link iframe fancy')
								.attr('data-fancybox','')
								.attr('data-type','iframe')
								.attr('title',window.translate('restaurant.actions.trame.label'))
								.append(
									$('<i/>')
									.addClass('fas fa-search')
								);
								btns.push($btnTrame);

								for(var i in btns){
									let $btn = btns[i];
									$list.append(
										$('<li/>')
										.addClass('list-inline-item')
										.append($btn)
									);
								}
		
								//@todo rest of buttons
		
								return $list;
							},
						},
		
					]
				})
				
			},

            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        };

        let query = new GraphQLQuery(attributes);
        query.execute();
	}
}
module.exports = RestaurantsTab;